/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_DescriptionInputs */

const en_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const fr_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

const it_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione`)
};

const ru_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание`)
};

const es_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción`)
};

const zh_cn2_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述`)
};

const ja_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明`)
};

const hi_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण`)
};

const pt_pt2_manual_qc_export_description = /** @type {(inputs: Manual_Qc_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Manual_Qc_Export_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_description = /** @type {((inputs?: Manual_Qc_Export_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_description(inputs)
	if (locale === "de") return de_manual_qc_export_description(inputs)
	if (locale === "it") return it_manual_qc_export_description(inputs)
	if (locale === "ru") return ru_manual_qc_export_description(inputs)
	if (locale === "es") return es_manual_qc_export_description(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_description(inputs)
	if (locale === "ja") return ja_manual_qc_export_description(inputs)
	if (locale === "hi") return hi_manual_qc_export_description(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_description(inputs)
	return en_manual_qc_export_description(inputs)
});